<template>
    <div>
        <section class="activate-membership section" v-if="stepNext == 0">
            <div class="container">
                <h1 class="title page-title has-padding-v-50 is-4 has-text-centered">Activate Connected Supplier Membership</h1>

                <div class="activate-membership__text">
                    <p>
                      Your monthly membership fee of £75 + vat is fully refundable against commissions on sales of your product in the marketplace.
                    </p>
                    <p>
                      It is to cover the admin cost of managing your account and connection until you have active sales of your product.
                    </p>
                    <p>
                      For full details <a class="activate-membership__link" @click.prevent="$router.push('/faqs')">click here to go to FAQs</a>.
                    </p>
                </div>

                <div class="activate-membership__form container">
                    <!-- Card Details Form -->
                    <div class="form-card">
                        <form action="http://127.0.0.1/charge" method="post" id="payment-form" >
                            <div class="form-row">
                                <div id="card-errors" role="alert">
                                    <span v-if="errorcard.error === true" class="is-danger error-message" v-html="errorcard.msg"></span>
                                    <span v-else class="text-success" v-html="errorcard.msg"></span>
                                </div>
                                <div id="card-element">
                                    <div class="field">
                                        <span class="brand"><i class="pf pf-credit-card" id="brand-icon"></i></span>
                                        <div id="card-element-card-number"></div>
                                        <label for="card-element-card-number">Card Number</label>
                                    </div>
                                    <div class="field half-width">
                                        <div id="card-element-card-expiry"></div>
                                        <label for="card-element-card-expiry">Expiration Date</label>
                                    </div>
                                    <div class="field half-width card-cvc">
                                        <div id="card-element-card-cvc"></div>
                                        <label for="card-element-card-cvc">CVC Code</label>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>

                    <a class="button btn-next activate-membership__button" @click.prevent="save">Activate Membership</a>

                </div>
            </div>
        </section>
        <section class="activate-membership section" v-if="stepNext == 1">
            <div class="container">

                <div class="activate-membership__text">
                    <h1 class="title page-title has-padding-v-50 is-4 has-text-centered">Thank you. You have successfully activated your Connected Supplier Membership.</h1>

                    <p>
                      You can begin the integration process of connecting your product to BestAgent Marketplace, so that agent users will see and activate automatic access to your product, listed in their “My Suppliers” page.
                    </p>
                    <p>
                      The next step is to tell us the name and contact details for the technical coder or software developer who will perform the connection work.
                    </p>
                </div>
                <div class="activate-membership__form container">
                    <a class="button btn-next activate-membership__button" @click.prevent="$router.push('/contact/technical')">Enter Coder Details</a>
                </div>
            </div>
        </section>
        <b-loading :is-full-page="true" :active="isLoading"></b-loading>
    </div>
</template>

<script>
import api from '../libs/api';

var cardNumber, cardExpiry, cardCvc, stripe, elements;
export default {
  name: 'activate',
  data() {
    return {
      supplier: {},
      isLoading: false,
      stepNext: 0,
      manualCharge: false,
      errorcard: "",
      cards: [],
      default_card: "",
      hascard: false,
      loadingcard: false,
      paymentMethodDialog: false,
      isPayPal: false,
    }
  },
  created: async function() {
		const that = this;
    this.supplier = await api({
      endpoint: `${process.env.VUE_APP_API}/suppliers`,
      path: '/info',
      method: 'GET',
    });

    if (this.supplier.paid == true || this.supplier.primary === true) {
      if (this.supplier.technical && this.supplier.technical.email && this.supplier.technical.email != '') {
        this.$router.push('/');
      } else {
        this.stepNext = 1;
      }
    } else {
  		const getinfo = await api({endpoint: `${process.env.VUE_APP_API}/payments`, path: '/', method: 'GET'});
      if (getinfo.cards && getinfo.cards.cards && getinfo.cards.cards.length !== 0) {
  		  this.hascard = true;

        await this.tryCharge();
  		}
    }
  },
  async mounted() {
    const that = this;
    const script = document.createElement('script');
    script.src = "https://js.stripe.com/v3/";
    document.head.appendChild(script);
    setTimeout(function() {
  		stripe = Stripe(process.env.VUE_APP_STRIPE);
  		elements = stripe.elements();
      that.setupCard();
    },2000);
   },
  methods: {
    setupCard() {
			var style = {
				base: {
					color: '#424F65',
					lineHeight: '18px',
					fontFamily: '"Muli", sans-serif',
					fontSmoothing: 'antialiased',
					fontSize: '16px',
					'::placeholder': {
						color: '#D1D1D1',
					},
					':-webkit-autofill': {
						color: '#FFCCA5',
					},
				},
				invalid: {
					color: '#bf4336',
					iconColor: '#bf4336'
				}
			};

			let that = this;

			 // Floating labels
			  var inputs = document.querySelectorAll('#payment-form .InputElement');
			  Array.prototype.forEach.call(inputs, function(input) {
				  input.addEventListener('focus', function() {
					  input.classList.add('focused');
				  });
				  input.addEventListener('blur', function() {
					  input.classList.remove('focused');
				  });
				  input.addEventListener('keyup', function() {
					  if (input.value.length === 0) {
						  input.classList.add('empty');
					  } else {
						  input.classList.remove('empty');
					  }
				  });
			  });

			  var elementClasses = {
				 focus: 'focused',
				 empty: 'empty',
				 invalid: 'invalid',
			  };
			 // Create an instance of the card Element.
			if (!cardNumber) {
				 cardNumber = elements.create('cardNumber', {
					style: style,
					classes: elementClasses,
					placeholder: ''
				 });
			 }
			 cardNumber.mount('#card-element-card-number');

			 if (!cardExpiry) {
				 cardExpiry = elements.create('cardExpiry', {
					style: style,
					classes: elementClasses,
					placeholder: 'MM/YY'
				 });
			 }
			 cardExpiry.mount('#card-element-card-expiry');
			 if (!cardCvc) {
				 cardCvc = elements.create('cardCvc', {
					style: style,
					classes: elementClasses,
					placeholder: ''
				 });
			 }
			 cardCvc.mount('#card-element-card-cvc');

			 // registerElements([cardNumber, cardExpiry, cardCvc], 'card-element');

			// Add an instance of the card Element into the `card-element` <div>.
			// card.mount('#card-element');
			// Handle real-time validation errors from the card Element.
			cardNumber.addEventListener('change', function(event) {
			  var displayError = document.getElementById('card-errors');
			  if (event.brand) {
				 that.setBrandIcon(event.brand);
			  }
			  if (event.error) {
				 that.errorcard = {error: true, msg: event.error.message };
			  } else {
				 that.errorcard = {error: false, msg: '' };
			  }
			});
		},
		async setBrandIcon(brand) {
			var cardBrandToPfClass = {
			 'visa': 'pf-visa',
			  'mastercard': 'pf-mastercard',
			  'amex': 'pf-american-express',
			  'discover': 'pf-discover',
			  'diners': 'pf-diners',
			  'jcb': 'pf-jcb',
			  'unknown': 'pf-credit-card',
		  };
		   var brandIconElement = document.getElementById('brand-icon');
		   var pfClass = 'pf-credit-card';
		   if (brand in cardBrandToPfClass) {
		 	 pfClass = cardBrandToPfClass[brand];
		   }
		   for (var i = brandIconElement.classList.length - 1; i >= 0; i--) {
		 	 brandIconElement.classList.remove(brandIconElement.classList[i]);
		   }
		   brandIconElement.classList.add('pf');
		   brandIconElement.classList.add(pfClass);
	   },
    async save() {
      this.isLoading = true;
      const that = this;
      // Update card
      await this.sendCard();
      // Try charge subscription
      //setTimeout(async function(){
        await that.tryCharge();
        that.isLoading = false;
      //},2000);
    },
    async tryCharge() {
      const returnapi = await api({ endpoint: `${process.env.VUE_APP_API}/suppliers`, path: '/activate', method: 'GET' });
			if (returnapi.paid && returnapi.paid == true) {
        if (this.supplier.technical && this.supplier.technical.email && this.supplier.technical.email != '') {
          this.$router.push('/');
        } else {
          this.stepNext = 1;
        }
      } else {
        this.errorcard = {error: returnapi.error, msg: returnapi.msg ? returnapi.msg : "There was a problem charging your card, please fix this issue." };
      }
    },
    async sendCard() {
			let that = this;
			this.loadingcard = true;
			this.hascard = false;
			this.errorcard = { error: false, msg: "" };
			const result = await stripe.createToken(cardNumber);
			 if (result.error) {
				// Inform the user if there was an error.
				that.errorcard = { error: true, msg: result.error.message };
				that.loadingcard = false;
        return false;
			 } else {
				// Send the token to your server.
				if (result.token && result.token.card) {
					const tokencard = result.token.id;
					const newcard = await api({endpoint: `${process.env.VUE_APP_API}/payments/set-card/${tokencard}`, path: '', method: 'GET'});
					if (newcard && newcard.return === true) {
						that.cards[0] = result.token.card;
						that.cards[0].cvc_check = 'pass';
						that.hascard = true;
						that.errorcard = {error: false, msg: ""};
						that.loadingcard = false;
						that.paymentMethodDialog = false;
            return true;
					} else {
						that.loadingcard = false;
						that.paymentMethodDialog = false;
						that.errorcard = {error: true, msg: newcard.msg ? newcard.msg : "Something went wrong adding your card, please try again, another one, or contact BestAgent team."};
            return false;
					}
				} else {
					that.loadingcard = false;
					that.paymentMethodDialog = false;
					that.errorcard = {error: true, msg: "Please contact BestAgent team or try again later." };
          return false;
				}
			 }
		}
  }
};

</script>
<style>
.form-card {
  border: 1px solid #e7e7e7;
  background-color: #f9f9f9;
  padding:15px;
  margin:15px;
  min-width: 400px;
  width: 40%;
  margin-left: auto;
  margin-right: auto
}
input,
.StripeElement {
  height: 40px;
  padding: 10px 12px;

  color: #32325d;
  background-color: white;
  border: 1px solid transparent;
  border-radius: 4px;

  box-shadow: 0 1px 3px 0 #e6ebf1;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
}

input:focus,
.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}
</style>
